export default "__VITE_ASSET__ea59e66f__"